import { Box, Card, CardContent, Typography } from "@mui/material";

export function SupportUserGate() {
  return (
    <>
      <Box sx={{ display: "grid", minWidth: "1070px" }} m={2} mb={0}>
        <Card variant="outlined" sx={{ maxWidth: 500 }}>
          <CardContent>
            <Typography sx={{ paddingBottom: "1rem" }}>
              Support Console Unavailable
            </Typography>

            <Typography>
              The support console is disabled while a support access activation
              session is active. You're currently impersonating a user. To
              continue, please end the current support session and return to
              your own account.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
